import "core-js/modules/es.array.concat";
import "core-js/modules/es.string.search";
import { parse as parseQueryString } from 'querystring';
export default (function (location) {
  if (location && location.search) {
    var webviewParam = parseQueryString((location.search || '').substr(1)).webview ? 'webview=1&' : '';
    return "/login?".concat(webviewParam, "returnTo=").concat(encodeURIComponent(location.pathname + location.search));
  }

  return "/login".concat(location ? location.pathname : '');
});